import styles from './Report.module.scss';

export const ReportGroup = ({ title, children, ...rest }) => (
  <div className={styles.group} {...rest}>
    <div className={styles.heading}>{title}</div>
    {children}
  </div>
);
